// extracted by mini-css-extract-plugin
export default {"wrapper":"ChargingStats_wrapper__xA6cP","segment":"ChargingStats_segment__AKlO7","icon":"ChargingStats_icon__A8aBa"};